import {
  FORGOT_PASSWORD_REQUEST,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAILURE,
  RESET_FORGOT_PASSWORD_STATE,
} from "../../actionTypes/forgotPassword";

interface ForgotPasswordPayload {
  emailOrPhone: string;
}

export const forgotPasswordRequest = (payload: ForgotPasswordPayload) => ({
  type: FORGOT_PASSWORD_REQUEST,
  payload,
});

export const forgotPasswordSuccess = (data: string) => ({
  type: FORGOT_PASSWORD_SUCCESS,
  payload: data,
});

export const forgotPasswordFailure = (error: string) => ({
  type: FORGOT_PASSWORD_FAILURE,
  payload: error,
});

export const resetforgotPasswordStata = () => ({
  type: RESET_FORGOT_PASSWORD_STATE,
});
